module.exports = __webpack_public_path__ + "img/수면 아이콘.d08b3a25.png";